import { __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import NvLabel from '../NvLabel/NvLabel.esm.js';
import RadioIcon from './RadioIcon.esm.js';
import RadioWrapper from './RadioWrapper.esm.js';

var VariantInline = function (props) {
    var selected = props.selected, disabled = props.disabled, label = props.label, customLabel = props.customLabel;
    return (React.createElement(RadioWrapper, __assign({ variantClass: "nv-radio-button--inline" }, props),
        React.createElement(RadioIcon, { disabled: disabled, selected: selected }),
        React.createElement(NvLabel, { className: "nv-cursor-pointer", "cy-test": "textRow", isHidden: !!customLabel, value: label }),
        customLabel));
};

export { VariantInline as default };
//# sourceMappingURL=VariantInline.esm.js.map
